(function () {
    'use strict';

    angular
        .module('planInitiativeModule')
        .controller('grcPlanInitiativeAssessmentSelectorController', Controller);

    Controller.$inject = ['$scope', '$state', '$stateParams'];

    function Controller($scope, $state, $stateParams) {

        $scope.isInitAssessmentActive = function (initAssessment) {
            return initAssessment.PlanInitiative.PlanInitiativeID === $stateParams.PlanInitiativeID;
        };

        $scope.goToInitiative = function (initAssessment) {

            if ($state.includes('initiativeUpdateStatusAssess.initiatives.assess')) {
                // Assessment
                $state.go('initiativeUpdateStatusAssess.initiatives.assess.byInitiativeDeliverables', {
                    PlanInitiativeID: initAssessment.PlanInitiative.PlanInitiativeID
                });
            }

            else if ($state.includes('initiativeUpdateStatusReview.initiatives.review')) {
                // Review
                $state.go('initiativeUpdateStatusReview.initiatives.review.byInitiative.deliverables', {
                    PlanInitiativeID: initAssessment.PlanInitiative.PlanInitiativeID
                });
            }
        };
    }
})();